import { useQuery } from "@/api/swr/useQuery";
import { assessmentResultSchema } from "@/schema/assessment-results/AssessmentResult";

type Config = Parameters<typeof useQuery<typeof assessmentResultSchema>>[2];

export function useGetAssessmentResult(
  id: string,
  isFirstTime: boolean,
  config?: Config,
) {
  return useQuery(
    assessmentResultSchema,
    `/app/assessment_results/${id}?is_first_time=${isFirstTime}`,
    config,
  );
}
